// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3GNL3","clinicsSelect":"TableHeading_clinicsSelect___3-CV"};